// extracted by css-extract-rspack-plugin
export default {"drawerTableBox":"drawerTableBox-BuqAOH","drawerFormBox":"drawerFormBox-XA7DCz"};